// import Address from '@/store/models/Address'

export const EBiennial = {
    namespaced: true,
state: {
    EBiennialFiling: {
        dosId: '',
        entityName: '',
        entityType: '',
        entityTypeInVue: '',
        feeAmount: '',
        filingPeriod: '',
        ceo: {
            name: '',
            address: {
                line1: '',
                line2: '',
                city: '',
                state: '',
                zipCode: '',
                postalcode: '',
                country: '',
            },

        },
        prinExecOfficeInfo: {
            name: '',
            address: {
                line1: '',
                line2: '',
                city: '',
                state: '',
                zipCode: '',
                postalcode: '',
                country: '',
            },
        },
        womanBoardMember: {
            totalBoardMemberNumber: '',
            totalWomenBoardMemberNumber: '',
        },
        serviceOfProcessInfo: {
            name: '',
            address: {
                line1: '',
                line2: '',
                city: '',
                state: '',
                zipCode: '',
                postalCode: '',
                country: '',
            },
        },
        filerInfo: {
            name: '',
            address: {
                line1: '',
                line2: '',
                city: '',
                state: '',
                zipCode: '',
                postalCode: '',
                country: '',
            },
        },
        farmCorpExemptionFlag: false,
        signerInformation: {
            signature: false,
            signerName: '',
            signerTitle: '',
        },
        emailForEBiennial: '',
        fictiousName: '',
        dosFilingDate: '',
        county: '',
        jurisdiction: '',
        entityTypeDesc: '',
        transmittalDatetime: '',
        payment: {
            paymentId: '',
            paidAmount: 0.0,
            totalFee: 0.0,
            paymentMethod: '',
            paymentStatus: '',
            payeeName: '',
            paymentReason: '',
            paymentDate: '',
            submissionDate: '',
            paymentComment: '',
            paymentProviderResponse: '',
            creditCardInfo: {
                merchantId: '',
                cCtransactionId: '',
                payeeAddressLine1: '',
                payeeAddressLine2: '',
                payeeAddressCity: '',
                payeeAddressState: '',
                payeeAddressZip: '',
                payeeAddressCountry: '',
                payeePhone: '',
                payeeEmail: '',
                paymentCardNumber: '',
                paymentCardType: '',
                paymentAuthCode: '',

            },
        },
        submitterInfo: {
            submitterIP: '',
            submitterSysID: '',
            timestamp: '',
            submitterName: '',
            postalAddress: {
                name: '',
                streetAddress: '',
                addressLine2: '',
                city:  '',
                state: '',
                zipCode: '',
                zipPlus4: '',
                country: '',
                countryCode: '',
            },
            emailAddress: '',
            secondaryEmailAddress: '',
            submittedUserID: '',
            serviceCompanyCode: '',
        },
    },
    EbiennialTransactionData: [],
},
    getters: {
        EBiennialFiling: (state: { EBiennialFiling: object; }) => state.EBiennialFiling,
        getEbiennialTransactionData: (state: { EbiennialTransactionData: any; }) => state.EbiennialTransactionData,
    },

    mutations: {
        setEBiennialData(state: { EBiennialFiling: object; }, filingObject: object) {
            console.log('calling setEBiennialData');
            console.log(filingObject);
            state.EBiennialFiling = filingObject;
        },
        setEbiennialTransactionData(state: { EbiennialTransactionData: any; }, EbiennialTransactionDataFromDB: any) {
            state.EbiennialTransactionData = EbiennialTransactionDataFromDB;
        },


    },
};
